import { Component, HostListener, OnInit, inject } from '@angular/core';
import { FirestoreService } from '@services/firestore/firestore.service';
import { IConfiguracionesTexto } from '@interfaces/reforma-configuraciones-texto.interface';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-compensacion-mujeres',
  templateUrl: './compensacion-mujeres.component.html',
  styleUrl: './compensacion-mujeres.component.scss',
  standalone: false
})
export class CompensacionMujeresComponent implements OnInit {

  private readonly firestoreService = inject(FirestoreService);

  isVersionMobile = false;

  readonly content$: Observable<IConfiguracionesTexto> = this.firestoreService
    .getDoc<IConfiguracionesTexto>('reforma-pensiones', 'configuraciones-texto');

  ngOnInit(): void {
    this.updateVersion();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateVersion();
  }

  private updateVersion(): void {
    const width = window.innerWidth;
    const isInDesktopExceptionRange = width > 600 && width < 840;

    this.isVersionMobile = width < 1140 && !isInDesktopExceptionRange;
  }
}